import React from 'react';

import InternReferrals from '.';

const ReceptionistReferrals = () => {
  return <InternReferrals kind="receptionist" />;
};

export default ReceptionistReferrals;
